import { DataSource, Layout, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEdiCustomerList extends Layout {
    searchPanelCustomers: SearchPanel;
    sourceEdiCustomer: DataSource;
    switchCheckManualOrder: Switch;
    switchHold214ForReply: Switch;
    switchRequiresCorrectionInd: Switch;
    tableEdiCustomer: Table;
    textboxAltPartnerId: Textbox;
    textboxCarrier: Textbox;
    textboxCreditRebillFilter: Textbox;
    textboxCustomerId: Textbox;
    textboxDefaultCorrectionInd: Textbox;
    textboxPartnerId: Textbox;
    textboxPartnerName: Textbox;
    textboxScac: Textbox;
    textboxTransactionSet: Textbox;
    textboxTransactionType: Textbox;
    textboxVersion: Textbox;
}
